export default "__VITE_ASSET__DEJ$wNCk__"